import React from "react";
import Swal from "sweetalert2";
import emailjs from "emailjs-com";
import useTitle from "../../hooks/useTitle";
import { Form, Input, TextArea, Button } from "semantic-ui-react";
import "./contact.css"
const emailImg=`https://raw.githubusercontent.com/wdridoy11/web-icon/33cc25860932c06edfeb84f8ed162403d37fd6e4/mail.png`;
const whatsapp=`https://raw.githubusercontent.com/wdridoy11/web-icon/main/whatsapp.png`;

const Contact = () => {
  useTitle("Contact");
  const SERVICE_ID = process.env.REACT_APP_SERVICE_ID;
  const TEMPLATE_ID =process.env.REACT_APP_TEMPLATE_ID;
  const PUBLIC_KEY = process.env.REACT_APP_PUBLIC_KEY;
  
  const handleOnSubmit = (e) => {
    e.preventDefault();
    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, e.target, PUBLIC_KEY)
      .then((result) => {
        console.log(result.text);
        Swal.fire({
          icon: "success",
          title: "Message Sent Successfully"
        })
      }, (error) => {
        console.log(error.text);
        Swal.fire({
          icon: "error",
          title: "Ooops, something went wrong",
          text: error.text,
        })
      });
    e.target.reset()
  };

  return <div>
    <div className="bg-[#0E1629] py-20 lg:py-36">
        <div className="container mx-auto">
            <div className="grid md:grid-cols-2 gap-5">
                <div>
                <h1 className='text-5xl font-medium text-[#22d3ee] mb-5'>Contact Me</h1>
                    <div className="flex items-start gap-1">
                        <img className="w-12" src={emailImg} alt="email" />
                        <div>
                            <p className="text-xl mt-2">Email</p>
                            <p className="text-lg">ridoysharif30@gmail.com</p>
                        </div>
                    </div>
                    <div className="flex items-start gap-1 mt-5">
                        <img className="w-12" src={whatsapp} alt="whatsapp" />
                        <div>
                            <p className="text-xl mt-2">Call Me</p>
                            <p className="text-lg">(+880)1722824160</p>
                        </div>
                    </div>
                </div>
                <div>
                    <Form onSubmit={handleOnSubmit}>
                      <Form.Field
                          id="form-input-control-last-name"
                          className="contact-form"
                          control={Input}
                          name="user_name"
                          placeholder="Enter your name"
                          required
                        />
                        <Form.Field
                          id="form-input-control-email"
                          className="contact-form"
                          control={Input}
                          name="user_email"
                          placeholder="Enter your email"
                          required
                        />
                        <Form.Field
                          id="form-textarea-control-opinion"
                          className="contact-form"
                          control={TextArea}
                          name="user_message"
                          placeholder="Message"
                          required
                        />
                        <Button type="submit" className="btn text-white px-10 rounded-md mt-3 bg-[#22d3ee] hover:bg-[#28d3ede4]">Submit</Button>
                    </Form>
                </div>
            </div>
        </div>
    </div>
  </div>;
};

export default Contact;
